/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.tsx'
import { Route as SettingsRouteImport } from './routes/settings.tsx'
import { Route as DownloadsRouteImport } from './routes/downloads.tsx'
import { Route as AboutRouteImport } from './routes/about.tsx'
import { Route as IndexRouteImport } from './routes/index.tsx'
import { Route as WrappedIndexRouteImport } from './routes/wrapped/index.tsx'
import { Route as SessionIndexRouteImport } from './routes/session/index.tsx'
import { Route as WrappedUuidRouteImport } from './routes/wrapped/$uuid.tsx'
import { Route as SessionUuidRouteImport } from './routes/session/$uuid.tsx'
import { Route as HistoryExploreRouteImport } from './routes/history.explore.tsx'
import { Route as SessionUuidDetailRouteImport } from './routes/session/$uuid_.detail.tsx'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadsRoute = DownloadsRouteImport.update({
  id: '/downloads',
  path: '/downloads',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WrappedIndexRoute = WrappedIndexRouteImport.update({
  id: '/wrapped/',
  path: '/wrapped/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionIndexRoute = SessionIndexRouteImport.update({
  id: '/session/',
  path: '/session/',
  getParentRoute: () => rootRouteImport,
} as any)
const WrappedUuidRoute = WrappedUuidRouteImport.update({
  id: '/wrapped/$uuid',
  path: '/wrapped/$uuid',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionUuidRoute = SessionUuidRouteImport.update({
  id: '/session/$uuid',
  path: '/session/$uuid',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryExploreRoute = HistoryExploreRouteImport.update({
  id: '/history/explore',
  path: '/history/explore',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionUuidDetailRoute = SessionUuidDetailRouteImport.update({
  id: '/session/$uuid_/detail',
  path: '/session/$uuid/detail',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/downloads': typeof DownloadsRoute
  '/settings': typeof SettingsRoute
  '/history/explore': typeof HistoryExploreRoute
  '/session/$uuid': typeof SessionUuidRoute
  '/wrapped/$uuid': typeof WrappedUuidRoute
  '/session/': typeof SessionIndexRoute
  '/wrapped/': typeof WrappedIndexRoute
  '/session/$uuid/detail': typeof SessionUuidDetailRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/downloads': typeof DownloadsRoute
  '/settings': typeof SettingsRoute
  '/history/explore': typeof HistoryExploreRoute
  '/session/$uuid': typeof SessionUuidRoute
  '/wrapped/$uuid': typeof WrappedUuidRoute
  '/session': typeof SessionIndexRoute
  '/wrapped': typeof WrappedIndexRoute
  '/session/$uuid/detail': typeof SessionUuidDetailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/downloads': typeof DownloadsRoute
  '/settings': typeof SettingsRoute
  '/history/explore': typeof HistoryExploreRoute
  '/session/$uuid': typeof SessionUuidRoute
  '/wrapped/$uuid': typeof WrappedUuidRoute
  '/session/': typeof SessionIndexRoute
  '/wrapped/': typeof WrappedIndexRoute
  '/session/$uuid_/detail': typeof SessionUuidDetailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/downloads'
    | '/settings'
    | '/history/explore'
    | '/session/$uuid'
    | '/wrapped/$uuid'
    | '/session/'
    | '/wrapped/'
    | '/session/$uuid/detail'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/downloads'
    | '/settings'
    | '/history/explore'
    | '/session/$uuid'
    | '/wrapped/$uuid'
    | '/session'
    | '/wrapped'
    | '/session/$uuid/detail'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/downloads'
    | '/settings'
    | '/history/explore'
    | '/session/$uuid'
    | '/wrapped/$uuid'
    | '/session/'
    | '/wrapped/'
    | '/session/$uuid_/detail'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  DownloadsRoute: typeof DownloadsRoute
  SettingsRoute: typeof SettingsRoute
  HistoryExploreRoute: typeof HistoryExploreRoute
  SessionUuidRoute: typeof SessionUuidRoute
  WrappedUuidRoute: typeof WrappedUuidRoute
  SessionIndexRoute: typeof SessionIndexRoute
  WrappedIndexRoute: typeof WrappedIndexRoute
  SessionUuidDetailRoute: typeof SessionUuidDetailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/downloads': {
      id: '/downloads'
      path: '/downloads'
      fullPath: '/downloads'
      preLoaderRoute: typeof DownloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wrapped/': {
      id: '/wrapped/'
      path: '/wrapped'
      fullPath: '/wrapped/'
      preLoaderRoute: typeof WrappedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session/': {
      id: '/session/'
      path: '/session'
      fullPath: '/session/'
      preLoaderRoute: typeof SessionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wrapped/$uuid': {
      id: '/wrapped/$uuid'
      path: '/wrapped/$uuid'
      fullPath: '/wrapped/$uuid'
      preLoaderRoute: typeof WrappedUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session/$uuid': {
      id: '/session/$uuid'
      path: '/session/$uuid'
      fullPath: '/session/$uuid'
      preLoaderRoute: typeof SessionUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/explore': {
      id: '/history/explore'
      path: '/history/explore'
      fullPath: '/history/explore'
      preLoaderRoute: typeof HistoryExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session/$uuid_/detail': {
      id: '/session/$uuid_/detail'
      path: '/session/$uuid/detail'
      fullPath: '/session/$uuid/detail'
      preLoaderRoute: typeof SessionUuidDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  DownloadsRoute: DownloadsRoute,
  SettingsRoute: SettingsRoute,
  HistoryExploreRoute: HistoryExploreRoute,
  SessionUuidRoute: SessionUuidRoute,
  WrappedUuidRoute: WrappedUuidRoute,
  SessionIndexRoute: SessionIndexRoute,
  WrappedIndexRoute: WrappedIndexRoute,
  SessionUuidDetailRoute: SessionUuidDetailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
